<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>افزودن بنر تبلیغاتی</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="name" type="text" class="form__input" placeholder="عنوان">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="url" type="text" class="form__input" placeholder="لینک تصویر">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="landing_url" type="text" class="form__input" placeholder="لینک فرود">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="daily_views" type="text" class="form__input" placeholder="بازدید روزانه">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    {{start_date}}
                                    <DatePicker
                                            format="YYYY/MM/DD"
                                            displayFormat="jYYYY-jMM-jDD"
                                            v-model="start_date" label="تاریخ شروع" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <DatePicker
                                            format="YYYY/MM/DD"
                                            displayFormat="jYYYY-jMM-jDD"
                                            v-model="end_date"  label="تاریخ پایان" />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <label>ماکزیمم نمایش</label>
                                    <input v-model="max_views" type="text" class="form__input">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <label>وضعیت</label>
                                    <select v-model="status" >
                                        <option :value="1">فعال</option>
                                        <option :value="0">غیر فعال</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6" >
                        <div class="form__group">
                            <label>دیده شدن فقط در </label>
                            <treeselect v-model="poster_id"
                                        :multiple="true"

                                        :normalizer="normalizer_posters"
                                        :async="true"
                                        :loadOptions="load_posters"
                            />

                        </div>
                    </div>  <div class="col-12 col-lg-6" v-if="!first_data">
                    <div class="form__group">
                        <label style="color: white">ژانر ها</label>
                        <treeselect
                                :multiple="true"
                                v-model:modelValue="selected_genre"
                                :normalizer="normalizer_genres"
                                :options="genres"/>

                    </div>
                </div>
                    <div class="col-12 col-lg-6" v-if="!first_data">
                        <div class="form__group">
                            <label style="color: white">دسته بندی ها</label>
                            <treeselect

                                    v-model:modelValue="selected_category"
                                    :multiple="true"
                                    :normalizer="normalizer_cats"
                                    :disableBranchNodes="true"
                                    :options="categories"/>

                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button type="button" class="form__btn" @click="insert_data">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">

            <div class="row">
                <!-- main title -->
                <!-- end main title -->

                <!-- users -->
                <div class="col-12">
                    <Datatable
                            :items="items"
                            :fields="fields"
                            style="overflow: auto"
                            :items-per-page="20"
                            hover
                            height="300px"
                            border
                            striped
                            sorter
                            column-filter
                            pagination
                    >
                        <template #row="{item,index}">
                            <td>
                                <div class="main__table-text">{{index+1}}</div>
                            </td>
                        </template>
                        <template #start_date="{item}">
                            <td>
                                <div class="main__table-text">{{get_date(item.start_date)}}</div>
                            </td>
                        </template>
                        <template #end_date="{item}">
                            <td>
                                <div class="main__table-text">{{get_date(item.end_date)}}</div>
                            </td>
                        </template>
                        <template #status="{item}">
                            <td>
                                <div v-if="status==1" class="main__table-text">فعال</div>
                                <div  v-if="status==0" class="main__table-text">غیر فعال</div>
                            </td>
                        </template>

                        <template #url="{item}">
                            <td>
                                <a :href="item.video_url" target="_blank" class="main__table-text">لینک</a>

                            </td>
                        </template>


                        <template #operation="{item}">
                            <td>
                                <div class="main__table-btns">
                                    <!--                                    <div datas="#modal-status" class="main__table-btn main__table-btn&#45;&#45;banned open-modal">-->
                                    <!--                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,13a1.49,1.49,0,0,0-1,2.61V17a1,1,0,0,0,2,0V15.61A1.49,1.49,0,0,0,12,13Zm5-4V7A5,5,0,0,0,7,7V9a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V12A3,3,0,0,0,17,9ZM9,7a3,3,0,0,1,6,0V9H9Zm9,12a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Z"/></svg>-->
                                    <!--                                    </div>-->
                                    <!--                                    <div datas="#" class="main__table-btn main__table-btn&#45;&#45;view">-->
                                    <!--                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"/></svg>-->
                                    <!--                                    </div>-->
                                    <div @click="edit_item(item)" datas="#"
                                         class="main__table-btn main__table-btn--edit">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>
                                        </svg>
                                    </div>
                                    <div @click="delete_item(item)" datas="#modal-delete"
                                         class="main__table-btn main__table-btn--delete open-modal">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"/>
                                        </svg>
                                    </div>
                                </div>
                            </td>
                        </template>
                    </Datatable>

                </div>


            </div>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";
    import DatePicker  from 'vue3-persian-datetime-picker'
    import 'vue3-treeselect/dist/vue3-treeselect.css'
    import Treeselect from 'vue3-treeselect'
    import {ASYNC_SEARCH} from 'vue3-treeselect'

    const simulateAsyncOperation = fn => {
        setTimeout(fn, 200)
    }
    export default {
        name: 'HelloWorld',
        data() {
            return {
                first_data:false,
                selected_genre: [],
                genres: [],
                selected_category: [],
                categories: [],
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'name', label: 'نام'},
                    {key: 'url', label: 'لینک'},
                    {key: 'landing_url', label: 'لینک فرود'},
                    {key: 'daily_view', label: 'بازدید روزانه'},
                    {key: 'start_date', label: 'تاریخ شروع'},
                    {key: 'end_date', label: 'تاریخ پایان'},
                    {key: 'max_views', label: 'ماکزیمم نمایش'},
                    {key: 'status', label: 'وضعیت'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                name: '',
                url: '',
                daily_views: '',
                landing_url: '',
                start_date: '',
                end_date: '',
                status: 1,
                max_views: 0,
                poster_id: [],
                normalizer_genres(node) {
                    return {
                        id: node.id,
                        label: node.name,
                    }
                },
                normalizer_cats(node) {
                    return {
                        id: node.id,
                        label: node.name,
                    }
                },
                normalizer_posters(node) {
                    return {
                        id: node.id,
                        label: node.name,
                    }
                },
                load_posters({action, searchQuery, callback}) {
                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('search', searchQuery);

                            axios.post('search_posters', formData, {show_pros: true}).then(function (response) {
                                options = response.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },

            }
        },
        components: {
            Datatable,
            Treeselect,
            DatePicker
        },
        mounted() {
            this.get_data();
            this.get_genres();
            this.get_categories();
        },
        methods: {
            get_date(date){
                return new Date(date).toLocaleDateString('IR-fa')
            },
            edit_item(item) {
                var self = this
                this.name = item.name;
                this.url = item.video_url;
                this.landing_url = item.landing_url;
                this.daily_views = item.daily_view;
                this.start_date = item.start_date;
                this.end_date = item.end_date;
                this.max_views = item.max_views;
                this.status = item.status;
                this.status_form = item.id;
                this.first_data = true
                this.poster_id = []
                item.posters.forEach(function (val) {
                    self.poster_id.push(parseInt(val.poster_id))
                })
                this.selected_genre = []
                item.genres.forEach(function (val) {
                    self.selected_genre.push(parseInt(val.genre_id))
                })

                this.selected_category = []
                item.categories.forEach(function (val) {
                    self.selected_category.push(parseInt(val.cat_id))
                })

                setTimeout(function () {
                    self.first_data = false

                },500)
            },
            get_data() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_all_banner_advertise', formData, {}).then(function (response) {


                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.items = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            insert_data() {

                var self = this;
                if (this.name == "") {
                    return
                }
                var formData = new FormData();
                var url = 'add_banner_advertise'
                formData.append('name', this.name);
                formData.append('url', this.url);
                formData.append('landing_url', this.landing_url);
                formData.append('daily_views', this.daily_views);
                formData.append('start_date', this.start_date);
                formData.append('end_date', this.end_date);
                formData.append('max_views', this.max_views);
                formData.append('status', this.status);
                formData.append('poster_id', JSON.stringify(this.poster_id));
                formData.append('selected_genre', JSON.stringify(this.selected_genre));
                formData.append('selected_category', JSON.stringify(this.selected_category));

                if (this.status_form != 0) {
                    formData.append('id', this.status_form);
                    url = 'update_banner_advertise'
                }
                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.name = ''
                    self.status_form = 0;
                    self.$toast.success('ثبت با موفقیت انجام شد');

                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },
            get_genres() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_genres', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;

                    self.genres = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            get_categories() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_all_categories', formData, {}).then(function (response) {

                    var content_data = response.data.data;

                    // items = content_cats.orders;
                    content_data.forEach(function (val) {
                        val.children.forEach(function (val2) {
                            val2.value = val2.id;
                            val2.label = val2.name
                        })
                    })
                    self.categories = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
        }
    }
</script>

